package com.eladfinish.bible.contest.screens.search.usecases.engine.model

import com.eladfinish.bible.contest.screens.search.model.SearchMode

data class PrepareLocalSearchRequestInput(
    val searchedText: String,
    val searchMode: SearchMode,
    val isDebugUser: Boolean,
)
